<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="detail-bg"></div>
    <div class="container">
      <div class="page-header">
        <div class="icon-bar back" @click="handleBack"></div>
        <div
          class="page-title sub"
          v-if="
            info && (info.type === 1 || info.type === 2 || info.type === 3)
          ">
          {{ $t('sweepstake') }}
        </div>
      </div>
      <RuleBtn v-if="info && info.type === 3" type="6" />
      <div
        class="detail-box"
        v-if="info"
        :class="info.type === 4 || info.type === 5 ? 'type2' : 'type1'">
        <template>
          <div class="info">
            <div
              class="image"
              :style="{
                backgroundImage: 'url(' + $store.state.imgUrl + info.image + ')'
              }"></div>
            <div class="tit">{{ info.name }}</div>
            <div class="date" v-if="info.status === 1">
              {{ info.started_at }} - {{ info.locked_at }}
            </div>
            <div
              class="status-component"
              :class="'status' + info.status"
              v-else>
              {{ info.statusName }}
            </div>
            <div class="share" @click="handleShare">
              <span>{{ $t('share') }}</span>
            </div>
          </div>
          <div class="des">{{ info.instructions }}</div>
          <template v-if="info.status !== 3">
            <div class="jackpot">
              <div class="label">{{ $t('windfall') }}</div>
              <div class="val">{{ $handleNum(info.jackpot) }}</div>
            </div>
            <div
              class="jackpot pa"
              v-if="
                $store.state.token &&
                (info.type === 1 || info.type === 2 || info.type === 3) &&
                from === 'user'
              ">
              <div class="label">{{ $t('participation') }}</div>
              <div class="val">{{ $handleNum(info.my_bet_amount) }}</div>
            </div>
          </template>

          <div
            class="list5"
            v-if="
              (info.type === 1 || info.type === 2 || info.type === 3) &&
              from === 'user' &&
              info.status === 1
            ">
            <div class="flexable arrow" @click="handleTickets">
              <div class="label">{{ $t('tickets') }}</div>
              <div class="cont" v-if="$store.state.token">
                <span class="ticket">{{ $t('myticket') }}</span
                ><span class="num">{{ info.my_bet_count }}</span>
              </div>
            </div>
            <div class="des">{{ $t('activitypage.text1') }}</div>
          </div>

          <div class="title2" v-if="info.status === 3">
            <span>{{ $t('windfall') }}</span>
          </div>
          <template v-if="info.type === 1">
            <div
              class="score-list"
              v-for="(item, index) in info.score_options"
              :key="index">
              <div class="flexable">
                <div
                  class="name"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.home_image + ')'
                  }">
                  {{ item.home_team }}
                </div>
                <div class="vs">VS</div>
                <div
                  class="name"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.away_image + ')'
                  }">
                  {{ item.away_team }}
                </div>
              </div>
              <div
                class="score-box flexable"
                :class="
                  from === 'babe' || info.status !== 1 ? 'readyonly' : ''
                ">
                <div
                  class="box"
                  @click="
                    handleToSelect(
                      'score_options',
                      'home_score',
                      index,
                      'select'
                    )
                  ">
                  {{ item.home_score }}
                </div>
                <div class="m">:</div>
                <div
                  class="box"
                  @click="
                    handleToSelect(
                      'score_options',
                      'away_score',
                      index,
                      'select'
                    )
                  ">
                  {{ item.away_score }}
                </div>
              </div>
              <div class="des ac" v-if="info.status === 1">
                {{ $t('activitypage.text2') }}
              </div>
            </div>
          </template>
          <template v-if="info.type === 2">
            <div class="a2">
              <div
                class="flexable sm"
                v-for="(item, index) in info.match_options"
                :key="'a' + index">
                <div
                  class="name"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.home_image + ')'
                  }">
                  {{ item.home_team }}
                </div>
                <div class="vs">VS</div>
                <div
                  class="name"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.away_image + ')'
                  }">
                  {{ item.away_team }}
                </div>
              </div>
              <div
                class="score-list type2"
                v-for="(item, index) in info.top_scorer_options"
                :key="'b' + index">
                <div class="flexable">
                  <div
                    class="a"
                    :style="{
                      backgroundImage:
                        'url(' + $store.state.imgUrl + item.player_image + ')'
                    }"></div>
                  <div class="in">
                    <div
                      class="flag"
                      :style="{
                        backgroundImage:
                          'url(' +
                          $store.state.imgUrl +
                          item.player_country_image +
                          ')'
                      }"></div>
                    <div class="n">{{ item.player_name }}</div>
                  </div>
                  <div
                    class="num"
                    @click="
                      handleToSelect(
                        'top_scorer_options',
                        'player_score',
                        index,
                        'select'
                      )
                    ">
                    {{ item.player_score }}
                  </div>
                </div>
                <div class="des ac">{{ $t('activitypage.text2') }}</div>
              </div>
            </div>
          </template>
          <template v-if="info.type === 3">
            <div class="a3">
              <mt-navbar
                v-model="selected"
                class="center"
                style="margin-top: 0.2rem">
                <mt-tab-item id="1" clss="up">{{
                  $t('activitypage.text3')
                }}</mt-tab-item>
                <mt-tab-item id="2" clss="up">{{
                  $t('activitypage.text4')
                }}</mt-tab-item>
              </mt-navbar>
              <div class="des ac">{{ $t('activitypage.text5') }}</div>
              <!-- tab-container -->
              <mt-tab-container v-model="selected">
                <mt-tab-container-item id="1">
                  <div class="groups">
                    <div class="bg"></div>
                    <div
                      class="item"
                      v-for="(item, index) in info.options"
                      :key="index"
                      :class="'item' + item.game_id"
                      v-show="
                        [
                          '49',
                          '50',
                          '53',
                          '54',
                          '57',
                          '58',
                          '61',
                          '64'
                        ].indexOf(item.game_id) > -1
                      ">
                      <div class="box home_team">
                        <div
                          class="add"
                          :class="item.home_team_flag ? 'flag' : ''"
                          :style="{
                            backgroundImage:
                              'url(' +
                              $store.state.imgUrl +
                              item.home_team_flag +
                              ')'
                          }"
                          @click="
                            handleToSelect(
                              'options',
                              'home_team',
                              index,
                              'game'
                            )
                          "></div>
                      </div>
                      <div class="box away_team" v-if="item.game_id !== '64'">
                        <div
                          class="add"
                          :style="{
                            backgroundImage:
                              'url(' +
                              $store.state.imgUrl +
                              item.away_team_flag +
                              ')'
                          }"
                          @click="
                            handleToSelect(
                              'options',
                              'away_team',
                              index,
                              'game'
                            )
                          "></div>
                      </div>
                    </div>
                    <div class="groups-text text16">
                      {{ $t('add.text92') }}
                    </div>
                    <div class="groups-text text8">
                      {{ $t('add.text93') }}
                    </div>
                    <div class="groups-text text4">
                      {{ $t('add.text94') }}
                    </div>
                    <div class="groups-text textf">{{ $t('final') }}</div>
                  </div>
                </mt-tab-container-item>
                <mt-tab-container-item id="2">
                  <div class="groups reverse">
                    <div class="bg"></div>
                    <div
                      class="item"
                      v-for="(item, index) in info.options"
                      :key="index"
                      :class="'item' + item.game_id"
                      v-show="
                        [
                          '51',
                          '52',
                          '55',
                          '56',
                          '59',
                          '60',
                          '62',
                          '64'
                        ].indexOf(item.game_id) > -1
                      ">
                      <div class="box home_team" v-if="item.game_id !== '64'">
                        <div
                          class="add"
                          :class="item.home_team_flag ? 'flag' : ''"
                          :style="{
                            backgroundImage:
                              'url(' +
                              $store.state.imgUrl +
                              item.home_team_flag +
                              ')'
                          }"
                          @click="
                            handleToSelect(
                              'options',
                              'home_team',
                              index,
                              'game'
                            )
                          "></div>
                      </div>
                      <div class="box away_team">
                        <div
                          class="add"
                          :class="item.away_team_flag ? 'flag' : ''"
                          :style="{
                            backgroundImage:
                              'url(' +
                              $store.state.imgUrl +
                              item.away_team_flag +
                              ')'
                          }"
                          @click="
                            handleToSelect(
                              'options',
                              'away_team',
                              index,
                              'game'
                            )
                          "></div>
                      </div>
                    </div>
                    <div class="groups-text text16">
                      {{ $t('add.text92') }}
                    </div>
                    <div class="groups-text text8">
                      {{ $t('add.text93') }}
                    </div>
                    <div class="groups-text text4">
                      {{ $t('add.text94') }}
                    </div>
                    <div class="groups-text textf">{{ $t('final') }}</div>
                  </div>
                </mt-tab-container-item>
              </mt-tab-container>
              <div
                class="champion-box"
                :class="info.status === 1 ? '' : 'disabled'">
                <div class="box" @click="handleChampion">
                  <div
                    class="img"
                    @click="handleChampion"
                    v-if="champion"
                    :style="{
                      backgroundImage:
                        'url(' + $store.state.imgUrl + champion.image + ')'
                    }"></div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="info.type === 4">
            <div class="list-title4">
              {{ $t('new.text25') }}
            </div>
            <div class="choose-box">
              <div
                class="item"
                :class="
                  item.successed
                    ? 'success'
                    : item.is_right === 1
                    ? 'active'
                    : ''
                "
                v-for="(item, index) in info.forecast_options"
                @click="handleChoose('forecast_options', item)"
                :key="index">
                {{ index + 1 }}.
                {{ item.option }}
                <span class="p-select" v-if="info.my_join.my_option"></span>
              </div>
            </div>
          </template>
          <template v-if="info.type === 5">
            <div class="list-title4">
              {{ $t('new.text25') }}
            </div>
            <div class="choose-box">
              <div
                class="item"
                :class="
                  item.successed
                    ? 'success'
                    : item.is_right === 1
                    ? 'active'
                    : ''
                "
                v-for="(item, index) in info.vote_options"
                @click="handleChoose('vote_options', item)"
                :key="index">
                <div class="p-bg" :style="{ width: item.per }"></div>
                {{ index + 1 }}.
                {{ item.option }}
                <span class="p-val" v-if="item.per">{{ item.per }}</span>
              </div>
            </div>
          </template>
          <div
            class="list5"
            v-if="
              (info.type === 1 || info.type === 2 || info.type === 3) &&
              from === 'user' &&
              info.status !== 1
            ">
            <div class="flexable arrow" @click="handleTickets">
              <div class="label">{{ $t('tickets') }}</div>
              <div class="cont" v-if="$store.state.token">
                <span class="ticket">{{ $t('myticket') }}</span
                ><span class="num">{{ info.my_bet_count }}</span>
              </div>
            </div>
          </div>
          <template
            v-if="
              info.status === 3 &&
              (info.type === 1 || info.type === 2 || info.type === 3)
            ">
            <div
              class="greeting-box"
              v-if="info.win_score > 0 || info.lose_token > 0">
              <div class="txt">{{ $t('congratulations') }}🎉🎉🎉</div>
              <div class="dis">
                <span
                  v-if="info.win_score > 0 && info.lose_token <= 0"
                  v-htm="
                    $t('activitypage.text91', {
                      num: info.win_score,
                      type: $t('web5token')
                    })
                  "></span>
                <span
                  v-if="info.win_score <= 0 && info.lose_token > 0"
                  v-html="
                    $t('activitypage.text99', {
                      num: info.lose_token,
                      type: $t('krazetoken')
                    })
                  "></span>
                <span
                  v-if="info.win_score > 0 && info.lose_token > 0"
                  v-html="
                    $t('activitypage.text999', {
                      num1: info.win_score,
                      typ1: $t('web5token'),
                      num2: info.lose_token,
                      typ2: $t('krazetoken')
                    })
                  "></span>
              </div>
            </div>
            <div
              class="greeting-box"
              v-if="info.win_score <= 0 && info.lose_token <= 0">
              <div class="txt pity">{{ $t('activitypage.text21') }}</div>
              <div class="dis">{{ $t('activitypage.text22') }}</div>
            </div>
          </template>
          <template
            v-if="
              (info.type === 1 || info.type === 2 || info.type === 3) &&
              info.status !== 3
            ">
            <div class="list-title4">{{ $t('ranking') }}</div>
            <div class="list4">
              <div
                class="flexable"
                v-for="(item, index) in rankList"
                :key="index">
                <div class="label icon2">
                  <span>{{ item.rank }}.</span>{{ item.email }}
                </div>
                <div class="val">{{ $handleNum(item.web5_score) }}</div>
              </div>
            </div>
          </template>
          <template
            v-if="
              (info.type === 1 || info.type === 2 || info.type === 3) &&
              info.status === 3
            ">
            <div class="list-title4">{{ $t('winners') }}</div>
            <div class="list4">
              <div
                class="flexable"
                v-for="item in winnders"
                :class="item.self ? 'mine' : ''"
                :key="item.rank">
                <div class="label">{{ item.email }}</div>
                <div class="val">{{ $handleNum(item.win_score) }}</div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div
      class="footer"
      v-if="
        info &&
        info.status === 1 &&
        (info.type === 1 || info.type === 2 || info.type === 3) &&
        from === 'user'
      ">
      <div class="num-box">
        <div class="btn down" @click="handleDown"></div>
        <div class="put">
          <input
            v-if="info"
            v-model="info.price"
            type="number"
            oninput="value=value.replace(/[^\d]/g,'')"
            @blur="changeNum" /><span>{{ $t('token') }}</span>
        </div>
        <div class="btn up" @click="handleUp"></div>
        <div class="tipss" v-if="showTipss">
          {{ $t('add.text45', { price: 100 }) }}
        </div>
      </div>
      <el-button
        type="primary"
        @click="handleBuy"
        class="block el-button--special"
        >{{ $t('buy') }}</el-button
      >
    </div>
    <div
      class="footer"
      v-if="
        info &&
        info.status === 1 &&
        (info.type === 4 || info.type === 5) &&
        info.my_join &&
        info.my_join.my_option === '' &&
        from === 'user'
      ">
      <div class="num-box">
        <div class="btn down" @click="handleDown"></div>
        <div class="put">
          <input
            v-if="info"
            v-model="info.price"
            type="number"
            oninput="value=value.replace(/[^\d]/g,'')"
            @blur="changeNum" /><span>{{ $t('token') }}</span>
        </div>
        <div class="btn up" @click="handleUp"></div>
        <div class="tipss" v-if="showTipss">
          {{ $t('add.text45', { price: 100 }) }}
        </div>
      </div>
      <el-button
        type="primary"
        @click="handleBuy"
        class="block el-button--special"
        >{{ $t('buy') }}</el-button
      >
    </div>
    <div
      class="footer"
      v-if="
        info &&
        (info.type === 4 || info.type === 5) &&
        info.my_join &&
        info.my_join.my_option !== '' &&
        from === 'user'
      ">
      <div class="result-box" style="margin-top: 0.2rem">
        <div
          style="text-align: center; font-size: 0.24rem; margin-bottom: 0.2rem">
          <span v-if="info.my_join.is_win === 0">
            <div class="row">
              <span class="ti">{{ $t('new.text27') }}</span>
              <span class="pr">{{ $handleNum(info.my_bet_amount) }}</span>
            </div>
            <div class="des">{{ $t('new.text28') }}</div>
            <div class="des2">
              {{ $t('new.text29') }}
            </div>
          </span>
          <span v-if="info.my_join.is_win === 1">🎉🎉🎉</span>
          <span v-if="info.my_join.is_win === 2">💔💔💔</span>
        </div>
        <div class="h hh">
          <span v-if="info.my_join.is_win === 1">{{
            $t('congratulations')
          }}</span>
          <span v-if="info.my_join.is_win === 2">{{ $t('new.text30') }}</span>
        </div>
        <div
          class="dis"
          v-if="info.my_join.is_win !== 0 && info.my_join.is_win === 1"
          v-html="$t('new.text31', { price: info.my_join.win_score })"></div>
        <div
          class="dis"
          v-if="info.my_join.is_win !== 0 && info.my_join.is_win === 2"
          v-html="$t('new.text32', { price: info.my_join.lose_token })"></div>
      </div>
    </div>
    <div
      class="open-area"
      style="height: 1.7rem"
      v-if="info && from === 'user'"></div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <SharePop
        :sharePath="sharePath"
        @cancel="
          () => {
            this.popupVisible = false
          }
        "
        v-if="popType === 'share'" />
      <div class="pop-box buy" v-if="popType === 'success'">
        <div class="pop-title">{{ $t('purchaseticket') }}</div>
        <div class="result-box">
          <div class="h icons success">{{ $t('successed') }}</div>
          <div class="des">{{ $t('activitypage.text13') }}</div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 0.55rem"
          @click="
            () => {
              this.init()
              this.popupVisible = false
            }
          "
          >{{ $t('ok') }}</el-button
        >
      </div>
      <div class="pop-box buy" v-if="popType === 'buy'">
        <div class="pop-title">{{ $t('purchaseticket') }}</div>
        <div class="tips">{{ $t('activitypage.text14') }}</div>
        <template v-if="this.info.type === 1">
          <div
            class="score-list"
            v-for="(item, index) in info.score_options"
            :key="index">
            <div class="flexable">
              <div
                class="name"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + item.home_image + ')'
                }">
                {{ item.home_team }}
              </div>
              <div class="vs">VS</div>
              <div
                class="name"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + item.away_image + ')'
                }">
                {{ item.away_team }}
              </div>
            </div>
            <div
              class="score-box flexable"
              :class="from === 'babe' ? 'readyonly' : ''">
              <div class="box">{{ item.home_score }}</div>
              <div class="m">:</div>
              <div class="box">{{ item.away_score }}</div>
            </div>
          </div>
        </template>
        <template v-if="this.info.type === 2">
          <div class="a2">
            <div
              class="score-list type2 disabled"
              v-for="(item, index) in info.top_scorer_options"
              :key="'b' + index">
              <div class="flexable">
                <div
                  class="a"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.player_image + ')'
                  }"></div>
                <div class="in">
                  <div class="n">{{ item.player_name }}</div>
                  <div class="d">{{ $t('activitypage.text15') }}</div>
                </div>
                <div class="num">
                  {{ item.player_score }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="this.info.type === 3">
          <div class="box-list">
            <div class="flexable">
              <div
                class="flag"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + champion.image + ')'
                }"></div>
              <div class="name">
                {{ champion.name }} {{ $t('activitypage.text16') }}
              </div>
            </div>
          </div>
        </template>
        <template v-if="this.info.type === 4">
          <div class="choose-box">
            <div
              class="item active"
              v-for="(item, index) in info.forecast_options"
              v-show="item.is_right === 1"
              :key="index">
              {{ index + 1 }}.
              {{ item.option }}
            </div>
          </div>
        </template>
        <template v-if="this.info.type === 5">
          <div class="choose-box">
            <div
              class="item active"
              v-for="(item, index) in info.vote_options"
              v-show="item.is_right === 1"
              :key="index">
              {{ index + 1 }}.
              {{ item.option }}
            </div>
          </div>
        </template>
        <div class="line-list">
          <div class="flexable">
            <div class="label">{{ $t('ticketprice') }}</div>
            <div class="price">
              <span>{{ info && $handleNum(info.price) }}</span>
            </div>
          </div>
          <div class="flexable">
            <div class="label"></div>
            <div class="price">
              {{ $t('total') }}
              <span>{{ info && $handleNum(info.price) }}</span>
            </div>
          </div>
        </div>
        <el-button
          class="el-button--special block"
          style="margin-top: 0.34rem; color: #ffffff"
          :loading="loading2"
          @click="handleConfirm"
          >{{ $t('continue') }}</el-button
        >
      </div>
      <Tickets
        v-if="popType === 'list'"
        :type="info.type"
        :countries="countries"
        :list="ticketList" />
      <div class="pop-box select" v-if="popType === 'select'">
        <div class="pop-title">{{ $t('activitypage.text17') }}</div>
        <div class="scroll-box">
          <ul
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10">
            <li v-for="item in list" :key="item" @click="handleSelect(item)">
              <span>{{ item }} {{ $t('goal') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="pop-box select" v-if="popType === 'game'">
        <div class="pop-title">{{ $t('activitypage.text18') }}</div>
        <div class="scroll-box">
          <ul>
            <li
              v-for="(item, index) in gameList"
              :key="index"
              @click="handleSelect(item)"
              class="flex">
              <span
                class="flag"
                :style="{
                  backgroundImage:
                    'url(' + $store.state.imgUrl + item.image + ')'
                }"></span>
              <span class="name">{{ item.name }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="pop-close"
        v-if="popType !== 'success'"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import RuleBtn from '@/components/RuleBtn.vue'
import SharePop from '@/components/SharePop.vue'
import Tickets from '@/components/Tickets.vue'
import { Toast } from 'mint-ui'

export default {
  props: {
    from: {
      type: String,
      default: () => 'user'
    },
    postActivityCountries: {
      type: Function,
      default: () => {}
    },
    postActivityInfo: {
      type: Function,
      default: () => {}
    },
    postActivityInprocess: {
      type: Function,
      default: () => {}
    },
    postActivityJoin: {
      type: Function,
      default: () => {}
    },
    postActivityMine: {
      type: Function,
      default: () => {}
    },
    postActivityRank: {
      type: Function,
      default: () => {}
    },
    postActivityMyjoins: {
      type: Function,
      default: () => {}
    },
    postActivityWinlists: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    SharePop,
    Tickets,
    RuleBtn
  },
  data() {
    return {
      popupVisible: false,
      selected: '1',
      info: null,
      gameList: [],
      popType: null,
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      ticketList: null,
      currentIndex: null,
      currentType: null,
      currentParam: null,
      rankList: [],
      selectedCountries: {},
      champion: null,
      isChampion: false,
      activities: null,
      sharePath: '',
      showTipss: false,
      winnders: [],
      loading: false,
      loading2: false
    }
  },
  created() {
    this.init()
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  methods: {
    init() {
      let that = this
      this.champion = null
      if (this.$route.query && this.$route.query.rec_code) {
        let params = {
          rec_code: this.$route.query.rec_code
        }
        that
          .postActivityInfo(params)
          .then((res) => {
            if (res.data) {
              if (res.data.status === 1) {
                res.data.statusName = this.$t('inprogress')
                that.postActivityRank(params).then((res2) => {
                  this.rankList = res2.data
                })
              } else if (res.data.status === 2) {
                res.data.statusName = this.$t('tobedrawn')
                that.postActivityRank(params).then((res2) => {
                  this.rankList = res2.data
                })
              } else if (res.data.status === 3) {
                res.data.statusName = this.$t('finished')
                that.postActivityWinlists(params).then((res) => {
                  that.winnders = res.data
                })
              }
              this.info = res.data
              if (res.data.type === 3) {
                that.postActivityCountries().then((res2) => {
                  this.countries = res2.data
                })
              }
              if (res.data.type === 4) {
                if (
                  res.data.my_join.my_option &&
                  res.data.my_join.my_option !== ''
                ) {
                  res.data.forecast_options = res.data.forecast_options.map(
                    (item) => {
                      if (item.option_id === res.data.my_join.my_option) {
                        item.is_right = 1
                      }
                      return item
                    }
                  )
                }
              }
              if (res.data.type === 5) {
                if (
                  res.data.my_join.my_option &&
                  res.data.my_join.my_option !== ''
                ) {
                  res.data.vote_options = res.data.vote_options.map((item) => {
                    item.per =
                      parseInt((item.join_count / res.data.join_count) * 100) +
                      '%'
                    if (item.option_id === res.data.my_join.my_option) {
                      item.is_right = 1
                    }
                    return item
                  })
                }
              }
            } else {
              this.info = {}
              if (that.$store.state.token) {
                that.postActivityMine(this.queryParams).then((res) => {
                  this.activities = res.data.map((item) => {
                    if (item.status === 1) {
                      item.statusName = this.$t('inprogress')
                    } else if (item.status === 2) {
                      item.statusName = this.$t('tobedrawn')
                    } else if (item.status === 3) {
                      item.statusName = this.$t('finished')
                    }
                    return item
                  })
                })
              }
            }
          })
          .catch(() => {})
      } else {
        that
          .postActivityInprocess()
          .then((res) => {
            if (res.data) {
              this.info = res.data
              that
                .postActivityRank({ rec_code: res.data.rec_code })
                .then((res2) => {
                  this.rankList = res2.data
                })
              if (res.data.type === 3) {
                that.postActivityCountries().then((res2) => {
                  this.countries = res2.data
                })
              }
            } else {
              this.info = {}
              if (that.$store.state.token) {
                that.postActivityMine(this.queryParams).then((res) => {
                  this.activities = res.data.map((item) => {
                    if (item.status === 1) {
                      item.statusName = this.$t('inprogress')
                    } else if (item.status === 2) {
                      item.statusName = this.$t('tobedrawn')
                    } else if (item.status === 3) {
                      item.statusName = this.$t('finished')
                    }
                    return item
                  })
                })
              }
            }
          })
          .catch(() => {})
      }
    },
    handleBuy() {
      if (!this.info.price) {
        this.$toast({
          message: this.$t('activitypage.text19')
        })
        return
      }
      if (this.info.type === 3 && !this.champion) {
        this.$toast({
          message: this.$t('activitypage.text20')
        })
        return
      }
      if (this.info.type === 4) {
        let selected = this.info.forecast_options.find((item) => {
          return item.is_right === 1
        })
        if (!selected) {
          this.$toast({
            message: this.$t('new.text33')
          })
          return
        }
      }
      if (this.info.type === 5) {
        let selected = this.info.vote_options.find((item) => {
          return item.is_right === 1
        })
        if (!selected) {
          this.$toast({
            message: this.$t('new.text33')
          })
          return
        }
      }
      this.popType = 'buy'
      this.popupVisible = true
    },
    handleToSelect(type, param, index, popType) {
      if (this.info.status === 1 && this.from === 'user') {
        this.currentType = type
        this.currentParam = param
        this.currentIndex = index
        this.popType = popType
        this.isChampion = false
        if (popType === 'select') {
          this.loadMore()
          this.popupVisible = true
        }
        if (popType === 'game') {
          if (this.info[this.currentType][this.currentIndex].game_id === '49') {
            if (param === 'home_team') {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group A'
                )
              })
            } else {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group B'
                )
              })
            }
            this.popupVisible = true
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '50') {
            if (param === 'home_team') {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group C'
                )
              })
            } else {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group D'
                )
              })
            }
            this.popupVisible = true
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '51') {
            if (param === 'home_team') {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group D'
                )
              })
            } else {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group C'
                )
              })
            }
            this.popupVisible = true
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '52') {
            if (param === 'home_team') {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group B'
                )
              })
            } else {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group A'
                )
              })
            }
            this.popupVisible = true
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '53') {
            if (param === 'home_team') {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group E'
                )
              })
            } else {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group F'
                )
              })
            }
            this.popupVisible = true
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '54') {
            if (param === 'home_team') {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group G'
                )
              })
            } else {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group H'
                )
              })
            }
            this.popupVisible = true
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '55') {
            if (param === 'home_team') {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group F'
                )
              })
            } else {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group E'
                )
              })
            }
            this.popupVisible = true
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '56') {
            if (param === 'home_team') {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group H'
                )
              })
            } else {
              this.gameList = this.countries.filter((item) => {
                return (
                  !this.selectedCountries.hasOwnProperty(item.id) &&
                  item.group === 'Group G'
                )
              })
            }
            this.popupVisible = true
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '57') {
            if (param === 'home_team') {
              this.getChildList('53')
            } else {
              this.getChildList('54')
            }
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '58') {
            if (param === 'home_team') {
              this.getChildList('49')
            } else {
              this.getChildList('50')
            }
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '59') {
            if (param === 'home_team') {
              this.getChildList('55')
            } else {
              this.getChildList('56')
            }
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '60') {
            if (param === 'home_team') {
              this.getChildList('51')
            } else {
              this.getChildList('52')
            }
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '61') {
            if (param === 'home_team') {
              this.getChildList('57')
            } else {
              this.getChildList('58')
            }
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '62') {
            if (param === 'home_team') {
              this.getChildList('59')
            } else {
              this.getChildList('60')
            }
          }
          if (this.info[this.currentType][this.currentIndex].game_id === '64') {
            if (param === 'home_team') {
              this.getChildList('61')
            } else {
              this.getChildList('62')
            }
          }
        }
      }
    },
    getChildList(num) {
      let parent = this.info[this.currentType].find((item) => {
        return item.game_id === num
      })
      if (parent.home_team === 0 || parent.away_team === 0) {
        Toast({
          message: this.$t('activitypage.text26')
        })
      } else {
        this.gameList = [
          this.selectedCountries[parent.home_team],
          this.selectedCountries[parent.away_team]
        ]
        this.popupVisible = true
      }
    },
    handleSelect(val) {
      if (this.info.type === 3) {
        if (this.isChampion) {
          this.champion = val
        } else {
          if (
            this.info[this.currentType][this.currentIndex][this.currentParam]
          ) {
            delete this.selectedCountries[
              this.info[this.currentType][this.currentIndex][this.currentParam]
            ]
            this.clearBox()
          }
          this.info[this.currentType][this.currentIndex][this.currentParam] =
            val.id
          this.info[this.currentType][this.currentIndex][
            this.currentParam + '_flag'
          ] = val.image
          if (!this.selectedCountries.hasOwnProperty(val.id)) {
            this.selectedCountries[val.id] = val
          }
        }
      } else {
        this.info[this.currentType][this.currentIndex][this.currentParam] = val
      }
      this.popupVisible = false
    },
    clearBox() {
      let id = this.info[this.currentType][this.currentIndex].game_id
      let val =
        this.info[this.currentType][this.currentIndex][this.currentParam]
      if (id === '49') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (item.game_id === '61' && item.away_team === val) {
              item['away_team'] = 0
              delete item['away_team_flag']
            } else if (
              (item.game_id === '58' || item.game_id === '64') &&
              item.home_team === val
            ) {
              item['home_team'] = 0
              delete item['home_team_flag']
            }
            return item
          }
        )
      }
      if (id === '50') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (item.game_id === '64' && item.home_team === val) {
              item['home_team'] = 0
              delete item['home_team_flag']
            } else if (
              (item.game_id === '58' || item.game_id === '61') &&
              item.away_team === val
            ) {
              item['away_team'] = 0
              delete item['away_team_flag']
            }
            return item
          }
        )
      }
      if (id === '51') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (id === '60' && item.home_team === val) {
              item['home_team'] = 0
              delete item['home_team_flag']
            } else if (
              (item.game_id === '62' || item.game_id === '64') &&
              item.away_team === val
            ) {
              item['away_team'] = 0
              delete item['away_team_flag']
            }
            return item
          }
        )
      }
      if (id === '52') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (item.away_team === val) {
              if (id === '60' || id === '62' || id === '64') {
                item['away_team'] = 0
                delete item['away_team_flag']
              }
            }
            return item
          }
        )
      }
      if (id === '53') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (
              (item.game_id === '57' ||
                item.game_id === '61' ||
                item.game_id === '64') &&
              item.home_team === val
            ) {
              item['home_team'] = 0
              delete item['home_team_flag']
            }
            return item
          }
        )
      }
      if (id === '54') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (item.game_id === '57' && item.away_team === val) {
              item['away_team'] = 0
              delete item['away_team_flag']
            } else if (
              (item.game_id === '61' || item.game_id === '64') &&
              item.home_team === val
            ) {
              item['home_team'] = 0
              delete item['home_team_flag']
            }
            return item
          }
        )
      }

      if (id === '55') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (
              (item.game_id === '59' || item.game_id === '62') &&
              item.home_team === val
            ) {
              item['home_team'] = 0
              delete item['home_team_flag']
            } else if (item.game_id === '64' && item.away_team === val) {
              item['away_team'] = 0
              delete item['away_team_flag']
            }
            return item
          }
        )
      }
      if (id === '56') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (
              (item.game_id === '59' || item.game_id === '64') &&
              item.away_team === val
            ) {
              item['away_team'] = 0
              delete item['away_team_flag']
            } else if (item.game_id === '62' && item.home_team === val) {
              item['home_team'] = 0
              delete item['home_team_flag']
            }
            return item
          }
        )
      }

      if (id === '57') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (item.home_team === val) {
              if (item.game_id === '61' || item.game_id === '64') {
                item['home_team'] = 0
                delete item['home_team_flag']
              }
            }
            return item
          }
        )
      }

      if (id === '58') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (item.game_id === '64' && item.home_team === val) {
              item['home_team'] = 0
              delete item['home_team_flag']
            } else if (item.game_id === '61' && item.away_team === val) {
              item['away_team'] = 0
              delete item['away_team_flag']
            }
            return item
          }
        )
      }

      if (id === '59') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (item.game_id === '62' && item.home_team === val) {
              item['home_team'] = 0
              delete item['home_team_flag']
            } else if (item.game_id === '64' && item.away_team === val) {
              item['away_team'] = 0
              delete item['away_team_flag']
            }
            return item
          }
        )
      }
      if (id === '60') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (
              (item.game_id === '62' || item.game_id === '64') &&
              item.away_team === val
            ) {
              item['away_team'] = 0
              delete item['away_team_flag']
            }
            return item
          }
        )
      }
      if (id === '61') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (item.game_id === '64' && item.home_team === val) {
              item['home_team'] = 0
              delete item['home_team_flag']
            }
            return item
          }
        )
      }
      if (id === '62') {
        this.info[this.currentType] = this.info[this.currentType].map(
          (item) => {
            if (item.game_id === '64' && item.away_team === val) {
              item['away_team'] = 0
              delete item['away_team_flag']
            }
            return item
          }
        )
      }
      if (val === this.champion) {
        this.champion = null
      }
    },
    handleConfirm() {
      let that = this
      let options
      if (this.info.type === 1) {
        options = this.info.score_options
      } else if (this.info.type === 2) {
        options = this.info.top_scorer_options
      } else if (this.info.type === 3) {
        options = this.info.options
      } else if (this.info.type === 4) {
        options = this.info.forecast_options
      } else if (this.info.type === 5) {
        options = this.info.vote_options
      }
      let params = {
        rec_code: this.info.rec_code,
        web5_token: this.info.price,
        options: JSON.stringify(options)
      }
      if (this.info.type === 3) {
        if (!this.champion) {
          Toast({
            message: this.$t('activitypage.text20')
          })
          return false
        }
        params.champion = this.champion.id
      }
      if (
        localStorage.getItem('inviteCode') &&
        localStorage.getItem('inviteAct') &&
        localStorage.getItem('inviteAct') === this.info.rec_code
      ) {
        params.user_rec_code = localStorage.getItem('inviteCode')
      }
      that.loading2 = true
      that
        .postActivityJoin(params)
        .then((res) => {
          that.loading2 = false
          this.popType = 'success'
          this.$store.dispatch('setRefresh', {
            name: 'UserAccount',
            type: true
          })
        })
        .catch((err) => {
          console.log(err)
          this.popupVisible = false
        })
    },
    handleTickets() {
      this.postActivityMyjoins({ rec_code: this.info.rec_code }).then((res) => {
        this.ticketList = res.data
        this.$nextTick(() => {
          this.popType = 'list'
          this.popupVisible = true
        })
      })
    },
    handleChampion() {
      if (this.info.status === 1 && this.from === 'user') {
        this.popType = 'game'
        this.isChampion = true
        this.currentType = 'options'
        this.getChildList('64')
      }
    },
    handleShare() {
      if (!this.$store.state.token) {
        this.$bus.emit('handleLogin')
      } else {
        this.sharePath =
          this.$store.state.userPath +
          '/user/activity?inviteCode=' +
          this.$store.state.user_info.rec_code +
          '&inviteAct=' +
          this.info.rec_code +
          '&rec_code=' +
          this.info.rec_code
        this.popType = 'share'
        this.popupVisible = true
      }
    },
    loadMore() {
      console.log(1)
      this.loading = true
      setTimeout(() => {
        let last = this.list[this.list.length - 1]
        for (let i = 1; i <= 10; i++) {
          this.list.push(last + i)
        }
        this.loading = false
      }, 2500)
    },
    handleDown() {
      if (this.info.price && this.info.price - 100 >= 100) {
        this.info.price -= 100
      } else {
        this.info.price = 100
        this.showTipss = true
      }
    },
    handleUp() {
      if (this.info.price) {
        this.info.price = parseInt(this.info.price) + 100
      } else {
        this.$set(this.info, 'price', 100)
      }
      if (this.info.price >= 100) {
        this.showTipss = false
      }
    },
    changeNum() {
      if (this.info.price) {
        this.info.price = parseInt(
          this.info.price.toString().replace(/^0+/g, '')
        )
        if (this.info.price < 100) {
          this.info.price = 100
          this.showTipss = true
        } else {
          this.showTipss = false
        }
      }
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleBack() {
      this.$router.back()
    },
    handleChoose(options, item) {
      if (
        this.info.my_join.my_option === '' &&
        this.info.status === 1 &&
        this.from === 'user'
      ) {
        this.info[options] = this.info[options].map((e) => {
          if (e.option_id === item.option_id) {
            this.answer = item.option_id
            e.is_right = 1
          } else {
            e.is_right = 0
          }
          return e
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ActBox.vue